<template>
  <div>
    <div class="page-wrap">
      <div class="page-headline"></div>
      <div class="page-content">
        <h4 class="page-title">
          <img :src="icon"
               alt="">上传资料
        </h4>
        <div class="page-upload">
          <Upload class="upload"
                  :action="baseURL + '/api/v1/web/user_form/sort_up_file'"
                  :before-upload="handleBeforeUpload"
                  :data="uploadParams"
                  :on-success="handleSuccess"
                  :headers="headers"
                  :max-size="50 * 1024">
            <div style="width: 350px;height: 274px;">
              <!-- <Icon type="ios-cloud-upload" size="52" style="color: #3399ff"></Icon> -->
              <img class="upload-icon"
                   :src="upload"
                   alt="">
              <p class="upload-txt">点击添加相关文件</p>
              <p class="upload-txt2">不超过50M</p>
            </div>
          </Upload>
          <p style="text-align: center;margin-top: 20px;margin-bottom: 20px;">如果文件超过50MB，请发送邮件至 imc2012@sina.cn（每次可接收2GB以内的文件），并另行通知威马捷。</p>
          <div class="text-center">
            <button class="btn"
                    @click="jump">跳过</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import icon from '@/assets/images/upload/icon-upload.png';
import upload from '@/assets/images/upload/icon-plus.jpg';
import { baseURL } from '@/api/axios'
import { getLocalStorage } from '@/utils/tools.js'
export default {
  data () {
    return {
      icon,
      upload,
      baseURL,
      uploadParams: {
        form_id: 0
      },
      headers: {
        // "Content-Type": "multipart/form-data", 
        Authorization: getLocalStorage('token')
      }
    }
  },
  computed: {
    form_id: {
      get: function () {
        return this.$route.params.form_id || localStorage.getItem('form_id');
      }
    }
  },
  mounted () {

  },
  methods: {
    handleBeforeUpload () {
      this.uploadParams.form_id = this.form_id;
    },
    handleSuccess (res, file) {
      if (res.code == 200) {
        this.$Message.success('上传成功！');
        this.$router.push('/myfile');
      } else {
        this.$Message.error(res.data.file[0]);
      }
    },
    jump () {
      this.$router.push('/myfile');
    }
  }
}
</script>
<style lang="less" scoped>
.page-wrap {
  width: 970px;
  border: 1px solid #dcdcdc;
  margin: 0 auto 30px;
}
.page-headline {
  position: relative;
  width: 100%;
  height: 10px;
  background: #333130;
}
.page-headline::before {
  position: absolute;
  left: 0;
  top: 0;
  display: block;
  width: 440px;
  height: 10px;
  background: #ae1e10;
  content: '';
}
.page-content {
  // height: 422px;
  background: #fff;
  overflow: hidden;
}
.page-title {
  font-size: 32px;
  color: #333130;
  line-height: 40px;
  margin-top: 40px;
  margin-left: 50px;
  img {
    width: 40px;
    height: 40px;
    vertical-align: top;
  }
}
.upload {
  width: 350px;
  height: 274px;
  background: #f6f6f6;
  border-radius: 4px;
  text-align: center;
  margin: 0 auto 40px;
}
.upload-icon {
  width: 66px;
  height: 66px;
  margin-top: 54px;
  margin-bottom: 30px;
}
.upload-txt {
  font-size: 22px;
  color: #333130;
  line-height: 28px;
  margin-bottom: 10px;
}
.upload-txt2 {
  font-size: 22px;
  color: #898888;
  line-height: 28px;
}
.btn {
  width: 200px;
  height: 50px;
  background: #ac4126;
  color: #fff;
  font-size: 20px;
  line-height: 40px;
  text-align: center;
  border: none;
  border-radius: 4px;
  margin-bottom: 50px;
}
</style>
